import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './baseQuery';

export const productImportsAPI = createApi({
    reducerPath: 'productImportsAPI',
    baseQuery: axiosBaseQueryWithReauth({
        baseUrl: process.env.REACT_APP_API_URL
    }),
    endpoints: (builder) => ({
        exportProductImportsCsv: builder.query<Blob, { clientId: number; orderBy?: string; searchTerm?: string; filters?: Record<string, unknown> }>({
            query: ({ clientId, orderBy, searchTerm, filters }) => ({
                url: 'ProductImports/export',
                method: 'GET',
                params: {
                    clientId,
                    orderBy,
                    searchTerm,
                    filters: filters ? JSON.stringify(filters) : undefined
                },
                responseType: 'blob'
            })
        }),
        exportProductImportDetailsCsv: builder.query<Blob, { productImportId: number; orderBy?: string; searchTerm?: string; filters?: Record<string, unknown> }>({
            query: ({ productImportId, orderBy, searchTerm, filters }) => ({
                url: `ProductImports/${productImportId}/details/export`,
                method: 'GET',
                params: {
                    orderBy,
                    searchTerm,
                    filters: filters ? JSON.stringify(filters) : undefined
                },
                responseType: 'blob'
            })
        }),
    }),
});

export const {
    useLazyExportProductImportsCsvQuery,
    useLazyExportProductImportDetailsCsvQuery,
} = productImportsAPI;
